import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

function convertDates(obj) {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }

    const userFormat = localStorage.getItem('dateformat') || 'DD/MM/YYYY';
    const current_user = JSON.parse(localStorage.getItem('user_prefrence'));
    if(current_user != null && current_user != undefined){
    obj['current_user_branch_id'] = current_user.branch_id;
    }
    Object.keys(obj).forEach(key => {
        const value = obj[key];

        if (value instanceof Date) {
            obj[key] = moment(value).format(userFormat);
        } else if (value && typeof value === 'object' && !(value instanceof File)) {
            convertDates(value);
        }
    });

    return obj;
}

function addExtraPayload(config) {
    document.querySelectorAll('.error-message').forEach(el => el.remove());
    if (config.data && !(config.data instanceof FormData)) {
        config.data = convertDates(config.data);
    }
    try {
        const action = window.currentAction;
        
        if (config.params && config.params.action) {

        } else {
            if (action) {
                const current_user = JSON.parse(localStorage.getItem('user_prefrence'));
                let current_branch_id
                if(current_user != null && current_user != undefined){
                    current_branch_id = current_user.branch_id;
                }
                if (config.method === 'get') {
                    config.params = {
                        ...config.params,
                        'current_user_branch_id':current_branch_id,
                        action
                    };
                } else {
                    if (config.data instanceof FormData) {
                        config.data.append('action', action);
                        config.data.append('current_user_branch_id', current_branch_id);
                    } else {
                        config.data = {
                            ...config.data,
                            'current_user_branch_id':current_branch_id,
                            action
                        };
                    }
                }
            }
        }
    }
    catch (error) {
        console.log(error)
        console.error('An error occurred:');
    }
   
    return config;
}

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
if (window.app.url) {
    axios.defaults.baseURL = window.app.url;
}
if (localStorage.getItem('token')) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}

axios.interceptors.request.use(config => {
    config = addExtraPayload(config);
    return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(function (response) {
    localStorage.removeItem('filters');
    return response;
}, function (error) {

    if (error.response.status === 401) {
        // If error 401 redirect to login
        if(error.response.data.message == 'Branch/Country Mismatch. Please Re-Login again.'){
            alert(error.response.data.message)
        }
        window.location.href = window.app.url + '/auth/login';
        delete window.axios.defaults.headers.common.Authorization;
        
        localStorage.removeItem('token');
        throw new Error('Unauthorized');
    }else if (error.response.status === 404) {
        window.location.href = window.app.url + '/modules/notaccess';
        Vue.notify({title: 'Error', text: message, type: 'error'});
    }else if (error.response.status === 429) {
       // window.location.href = window.app.url + '/modules/notaccess';
        Vue.notify({title: 'Error', text: message, type: 'error'});
    } else if (error.response.data.message) {
        // If it is a notification error, display message
        Ladda.stopAll();
        let message = error.response.data.message;
        if (error.response.data.errors) {
            message = '<ul class="text-left">';
            Object.keys(error.response.data.errors).forEach(function (element) {
                error.response.data.errors[element].forEach(function (item) {
                    message += '<li>' + item + '</li>';
                });
            });
            message += '</ul>';
        }
        Vue.notify({title: 'Error', text: message, type: 'error'});
        
        localStorage.setItem('Errors', JSON.stringify(error.response.data));
        throw new Error(error.response.data.errors);
    } else {
        // If it is an uncontrolled error, display http status
        Ladda.stopAll();
        Vue.notify({title: 'Error ' + error.response.status, text: error.response.statusText, type: 'error'});
        throw new Error(error);
    }
});

window.axios = axios;
